angular.module('impactx.search').controller('ThemeworldItemCtrl', [
    'ThemeWorldService',
    'TranslationService',
    'AppConfiguration',
    '$mdTheming',
    ThemeworldItemController
]);

function ThemeworldItemController(ThemeWorldService, TranslationService, AppConfiguration, $mdTheming) {
    var self = this;

    self.activateThemeworld = function (selectedThemeworldId) {
        ThemeWorldService.activateThemeWorldSearch(selectedThemeworldId);
    };

    self.showPanelLabel = AppConfiguration.get('showPanelLabels');
    self.getThemeColor = function() {
        if (self.themeworld.theme) {
            return $mdTheming.PALETTES[self.themeworld.theme][500].hex
        }
    };
}
